<template>
    <div class="chart-container" :style="{ 'position': 'relative', 'height':height + 'px', 'width':'100%' }">
      <LineChart :styles="myStyles" v-if="chartType==1" :chartType="chartType" :queryColumns="queryColumns" :queryResult="queryResult" :chartZoomResetKey="chartZoomResetKey" :queryID="queryID"/>
      <BarChart :styles="myStyles" v-if="chartType==2" :chartType="chartType" :queryColumns="queryColumns" :queryResult="queryResult" :chartZoomResetKey="chartZoomResetKey" :queryID="queryID"/>
      <PieChart :styles="myStyles" v-if="chartType==4" :chartType="chartType" :queryColumns="queryColumns" :queryResult="queryResult" :chartZoomResetKey="chartZoomResetKey" :queryID="queryID"/>

      <Gmap v-if="chartType==3" :chartType="chartType" :queryColumns="queryColumns" :queryResult="queryResult" :height="height"/>
      <Gantt v-if="chartType==22" :chartType="chartType" :queryColumns="queryColumns" :queryResult="queryResult" :height="height"/>

      <!--
          <AreaChart v-if="data.type==3" :rows="data"/>
          <RadarChart v-if="data.type==5" :rows="data"/>
      -->
    </div>
</template>
<script>
//import AreaChart from "./impl/AreaChart.vue";
//import RadarChart from "./impl/RadarChart.vue";
import BarChart from "./impl/BarChart.vue";
import LineChart from "./impl/LineChart3.vue"
import PieChart from "./impl/PieChart.vue";

import Gantt from "./Gantt.vue"
import Gmap from "./Gmap.vue"

export default {
  name: "Chart",
  props: ['chartType', 'queryColumns', 'queryResult', 'parentWindowSize', 'height', 'chartZoomResetKey', 'queryID'],
  components: {
    //AreaChart,
    //RadarChart,
    PieChart,
    BarChart,
    LineChart,
    Gantt,
    Gmap
  },
  computed: {
    myStyles() {
      return {
        windowSize: null,
        width: '99%',
        height: `${this.height}px`,
        position: 'relative'
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    resizeChartWindow() {
      logger.info("resize!")
    }
  },
  mounted: function () {
  }
}
</script>

<style lang="sass">
h2
  margin: 10px 0 10px 0
</style>
